import { requestPost } from '../utils/requestApi'

export async function postUserLogin(payload){
  return requestPost('token', payload)
}